import {OutlinedInputProps} from "@mui/material";
import {OutlinedInput as SharedOutlinedInput} from "@bounce/shared/ui";
import {outlinedInputSx} from "./inputStyles";

export const OutlinedInput = ({sx, ...props}: OutlinedInputProps) => (
  <SharedOutlinedInput
    sx={{...outlinedInputSx, ...sx}}
    {...props}
  />
);
